/* AISEN FLOOR — corte construtivo interativo (hotspots + popovers).
   Vanilla, escopado à section, sem bibliotecas. Um único popover aberto por vez.
   Sem JS a legenda abaixo da imagem já traz título e descrição de cada camada. */
(() => {
  const init = (root) => {
    if (root.dataset.fcfReady) return;
    root.dataset.fcfReady = '1';
    root.classList.add('is-js');

    const stage = root.querySelector('.aisen-fcf__stage');
    const hots = Array.prototype.slice.call(root.querySelectorAll('[data-fcf-hot]')); // pontos + itens da legenda
    const pops = Array.prototype.slice.call(root.querySelectorAll('[data-fcf-pop]'));
    const mob = root.querySelector('[data-fcf-mob]');
    const mobH = root.querySelector('[data-fcf-mobh]');
    const mobTx = root.querySelector('[data-fcf-mobtx]');
    if (!hots.length) return;

    let openId = null, hoverTimer = null, lastTrigger = null;

    const isMobile = () => window.matchMedia('(max-width: 749px)').matches;
    const popFor = (id) => pops.find((p) => p.getAttribute('data-fcf-pop') === id) || null;
    const elsFor = (id) => hots.filter((e) => e.getAttribute('data-fcf-hot') === id);
    const imgHotFor = (id) => hots.find((e) => e.getAttribute('data-fcf-hot') === id && e.classList.contains('aisen-fcf__hot')) || null;

    function closeAll(returnFocus) {
      if (openId === null) return;
      const pp = popFor(openId);
      if (pp) pp.hidden = true;
      if (mob) mob.hidden = true;
      elsFor(openId).forEach((e) => e.setAttribute('aria-expanded', 'false'));
      if (returnFocus && lastTrigger) lastTrigger.focus();
      openId = null;
    }

    // mantém o popover dentro da imagem e vira para baixo quando falta espaço acima
    function place(pop, hot) {
      pop.style.removeProperty('margin-left');
      pop.classList.remove('aisen-fcf__pop--below');
      pop.style.setProperty('--tail', '50%');
      const sb = stage.getBoundingClientRect();
      const pb = pop.getBoundingClientRect();
      const hb = hot.getBoundingClientRect();
      let shift = 0;
      if (pb.left < sb.left + 4) shift = (sb.left + 4) - pb.left;
      else if (pb.right > sb.right - 4) shift = (sb.right - 4) - pb.right;
      if (shift) {
        pop.style.marginLeft = shift + 'px';
        pop.style.setProperty('--tail', 'calc(50% - ' + shift + 'px)');
      }
      if (hb.top - pb.height - 24 < 0) pop.classList.add('aisen-fcf__pop--below');
    }

    function open(id, trigger) {
      if (openId === id) return;
      closeAll(false);
      const pop = popFor(id);
      if (!pop) return;
      openId = id;
      if (trigger) lastTrigger = trigger;
      elsFor(id).forEach((e) => e.setAttribute('aria-expanded', 'true'));
      if (isMobile()) {
        if (mob) {
          const t = pop.querySelector('.aisen-fcf__popn');
          const d = pop.querySelector('.aisen-fcf__poptx');
          if (mobH) mobH.textContent = t ? t.textContent.trim() : '';
          if (mobTx) mobTx.textContent = d ? d.textContent : '';
          mob.hidden = false;
        }
      } else {
        pop.hidden = false;
        const ih = imgHotFor(id);
        if (ih) place(pop, ih);
      }
    }

    hots.forEach((h) => {
      const id = h.getAttribute('data-fcf-hot');
      const isImgHot = h.classList.contains('aisen-fcf__hot');
      h.addEventListener('click', (e) => { e.preventDefault(); if (openId === id) closeAll(false); else open(id, h); });
      h.addEventListener('focus', () => { if (!isMobile()) open(id, h); });
      if (isImgHot) {
        h.addEventListener('mouseenter', () => { if (isMobile()) return; clearTimeout(hoverTimer); open(id, h); });
        h.addEventListener('mouseleave', () => { if (isMobile()) return; hoverTimer = setTimeout(() => closeAll(false), 180); });
      }
    });
    pops.forEach((pp) => {
      pp.addEventListener('mouseenter', () => clearTimeout(hoverTimer));
      pp.addEventListener('mouseleave', () => { if (!isMobile()) hoverTimer = setTimeout(() => closeAll(false), 180); });
    });
    root.querySelectorAll('[data-fcf-close]').forEach((b) => b.addEventListener('click', () => closeAll(true)));

    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && openId !== null) closeAll(true); });
    document.addEventListener('click', (e) => {
      if (openId === null) return;
      if (root.contains(e.target) && (e.target.closest('[data-fcf-hot]') || e.target.closest('[data-fcf-pop]') || e.target.closest('[data-fcf-mob]'))) return;
      closeAll(false);
    });
    root.addEventListener('focusout', () => {
      if (openId === null || isMobile()) return;
      setTimeout(() => {
        const a = document.activeElement;
        if (!a || (!a.closest('[data-fcf-hot]') && !a.closest('[data-fcf-pop]'))) closeAll(false);
      }, 0);
    });
    window.addEventListener('resize', () => closeAll(false));
  };

  const boot = () => document.querySelectorAll('[data-fcf-root]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // editor do tema: a section é re-renderizada ao editar
  document.addEventListener('shopify:section:load', boot);
})();
